import PrivateChannelListContainer from 'presentation/containers/modules/community/PrivateChannelListContainer';
import PrivateChannelLayout from 'presentation/layout/modules/privateChannel/PrivateChannelLayout';

import { FC } from 'react';

const PrivateChannelPage: FC = () => {
  return (
    <PrivateChannelLayout>
      <PrivateChannelListContainer />
    </PrivateChannelLayout>
  );
};

export default PrivateChannelPage;
